import React, { useState } from 'react';
import { Product } from '../services/product/types';
import { VendorTrackingDetails } from '../services/vendor/types';
import { ProductImgFallbackIcon } from '../icons';
import { formatCurrency } from '../common/utils';
import { useProductService } from '../services/product';
import { useExtension } from '../extension';
import { useDeeplinkModal } from '../modal';

interface Props {
    product: Product;
}

const ProductCard = ({ product }: Props) => {
    const { openDeepLink } = useExtension();
    const { requestRedirect } = useDeeplinkModal();
    const { getProductAffiliateUrl } = useProductService();
    const [imgError, setImgError] = useState(false);
    const [trackingDetails, setTrackingDetails] = useState<VendorTrackingDetails | null>(null);
    const [activated, setActivated] = useState(false);

    const primaryImage = product.imageUrls?.[0];

    const handleClick = () => {
        if (trackingDetails) {
            openDeepLink(trackingDetails);
        } else {
            getProductAffiliateUrl(String(product.id)).then(data => {
                const details = { ...data, period: 30 };
                requestRedirect(details);
                setTrackingDetails(details);
                setActivated(true);
            }).catch(() => {
                setActivated(false);
            });
        }
    };

    return (
        <div className="spp-product-card">
            <div className="spp-product-img-wrap">
                {!imgError && primaryImage ? (
                    <img
                        src={primaryImage}
                        alt={product.name}
                        className="spp-product-img"
                        onError={() => setImgError(true)}
                    />
                ) : (
                    <div className="spp-product-img-fallback">
                        <ProductImgFallbackIcon />
                    </div>
                )}
                {product.category && (
                    <span className="spp-category-pill">
                        {product.category}
                    </span>
                )}
            </div>

            <div className="spp-product-info">
                <div className="spp-product-name">{product.name}</div>
                <div className="spp-product-pricing">
                    <span className="spp-current-price">
                        {formatCurrency(product.price)}
                    </span>
                </div>
            </div>

            <button className="activate-btn" onClick={handleClick}>
                {trackingDetails ? 'Shop now' : activated ? 'Activating...' : 'Activate'}
            </button>
        </div>
    );
};

export default ProductCard;